import {
  DiscountInfo,
  PriceCalculationRequest,
} from "../priceCalculationInterfaces";

import { mapFromCommerceAdvice } from "Components/Features/CheckPrice/Products/Advice/mappers/mapFromCommerceAdvice";
import { mapFromCommerceAkaStudent } from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/mappers/mapFromCommerceAkaStudent";
import { mapFromCommerceAkaChild } from "Components/Features/CheckPrice/Products/LifeProducts/AkaChild/mappers/mapFromCommerceAkaChild";
import { mapFromCommerceAkaHealth } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/mappers/mapFromCommerceAkaHealth";
import { mapFromCommerceChild } from "Components/Features/CheckPrice/Products/LifeProducts/Child/mappers/mapFromCommerceChild";
import { mapFromCommerceChildHealth } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductPrice/ChildHealth/mapFromCommerceChildHealth";
import { mapFromCommerceHealthWithoutSigning } from "Components/Features/CheckPrice/Products/LifeProducts/Health/mappers/mapFromCommerceHealthWithoutSigning";
import { mapFromCommercePregnantAndNewborn } from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/mappers/mapFromCommercePregnantAndNewborn";
import { mapFromCommerceSopSicknessLeave } from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/mappers/mapFromCommerceSopSicknessLeave";
import { mapFromCommerceAccident } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/mappers/mapFromCommerceAccident";
import { mapFromCommerceAkaFamilyAccident } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/mappers/mapFromCommerceAkaFamilyAccident";
import { mapFromCommerceAkaTravel } from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel/mappers/mapFromCommerceAkaTravel";
import { mapFromCommerceAnimal } from "Components/Features/CheckPrice/Products/RiskProducts/Animal/mappers/mapFromCommerceAnimal";
import { mapFromCommerceAkaHouseContents } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/AkaHouseContents/mappers/mapToCommerceAkaHouseContents";
import { mapFromCommerceCabin } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/mappers/mapFromCommerceCabin";
import { mapFromCommerceCabinContents } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/mappers/mapFromCommerceCabinContents";
import { mapFromCommerceHouse } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/mappers/mapFromCommerceHouse";
import { mapFromCommerceHouseContents } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HouseContents/mappers/mapFromCommerceHouseContents";
import { mapFromCommerceHuseierneHouseContents } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/mappers/mapFromCommerceHuseierneHouseContents";
import { mapFromCommerceRental } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental/mappers/mapFromCommerceRental";
import { mapFromCommerceTravel } from "Components/Features/CheckPrice/Products/RiskProducts/Travel/mappers/mapFromCommerceTravel";
import { mapFromCommerceValuables } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables/mappers/mapFromCommerceValuables";
import { mapFromCommerceBoat } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/mappers/mapFromCommerceBoat";
import { mapFromCommerceCar } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/mappers/mapFromCommerceCar";
import { mapFromCommerceCaravan } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/mappers/mapFromCommerceCaravan";
import { mapFromCommerceElectricScooter } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/ElectricScooter/mappers/mapFromCommerceElectricScooter";
import { mapFromCommerceMoped } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Moped/mappers/mapFromCommerceMoped";
import { mapFromCommerceMotorcycle } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/mappers/mapFromCommerceMotorcycle";
import { mapFromCommerceTractor } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor/mappers/mapFromCommerceTractor";
import { mapFromCommerceTrailer } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Trailer/mappers/mapFromCommerceTrailer";
import { mapFromCommerceVeteranAuto } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/VeteranAuto/mappers/mapFromCommerceVeteranAuto";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { ChildPriceRequestInfo } from "Store/interfaces/products/checkPrice/lifeProducts/Child";
import { CabinPriceRequestInfo } from "Store/interfaces/products/checkPrice/riskProducts/CabinProducts/Cabin";
import { HousePriceRequestInfo } from "Store/interfaces/products/checkPrice/riskProducts/HouseProducts/House";

export function mapProductToForm(
  type: string,
  data: { [key: string]: any },
  isAdvisor = false,
  advice?: CollectiveAdvice,
): { [key: string]: any } {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (type) {
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return mapFromCommerceAccident(data);
    case INSURANCE_NAME_VALUE.ADVICE:
      return mapFromCommerceAdvice(data, isAdvisor, advice);
    case INSURANCE_NAME_VALUE.AKA_CHILD:
      return mapFromCommerceAkaChild(data);
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
      return mapFromCommerceAkaFamilyAccident(data);
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
      return mapFromCommerceAkaHealth(data);
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return mapFromCommerceAkaHouseContents(data);
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return mapFromCommerceAkaTravel(data);
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return mapFromCommerceAkaStudent(data);
    case INSURANCE_NAME_VALUE.ANIMAL:
      return mapFromCommerceAnimal(data);
    case INSURANCE_NAME_VALUE.BOAT:
      return mapFromCommerceBoat(data);
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return mapFromCommerceCabinContents(data);
    case INSURANCE_NAME_VALUE.CABIN:
      return mapFromCommerceCabin(data);
    case INSURANCE_NAME_VALUE.CAR:
      return mapFromCommerceCar(data);
    case INSURANCE_NAME_VALUE.CARAVAN:
      return mapFromCommerceCaravan(data);
    case INSURANCE_NAME_VALUE.CHILD:
      return mapFromCommerceChild(data);
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return mapFromCommerceChildHealth(data);
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return mapFromCommerceElectricScooter(data);
    case INSURANCE_NAME_VALUE.HEALTH:
      return mapFromCommerceHealthWithoutSigning(data);
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return mapFromCommerceHouseContents(data);
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return mapFromCommerceHuseierneHouseContents(data);
    case INSURANCE_NAME_VALUE.HOUSE:
      return mapFromCommerceHouse(data);
    case INSURANCE_NAME_VALUE.MOPED:
      return mapFromCommerceMoped(data);
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return mapFromCommerceMotorcycle(data);
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
      return mapFromCommercePregnantAndNewborn(data);
    case INSURANCE_NAME_VALUE.RENTAL:
      return mapFromCommerceRental(data);
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return mapFromCommerceSopSicknessLeave(data);
    case INSURANCE_NAME_VALUE.TRACTOR:
      return mapFromCommerceTractor(data);
    case INSURANCE_NAME_VALUE.TRAILER:
      return mapFromCommerceTrailer(data);
    case INSURANCE_NAME_VALUE.TRAVEL:
      return mapFromCommerceTravel(data);
    case INSURANCE_NAME_VALUE.VALUABLES:
      return mapFromCommerceValuables(data);
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return mapFromCommerceVeteranAuto(data);
    default:
      return data;
  }
}

type OldPriceRequests =
  | ChildPriceRequestInfo
  | HousePriceRequestInfo
  | CabinPriceRequestInfo;

type PriceRequestWithProductCount = OldPriceRequests & {
  numberOfProductsInCart: number;
};

export type PriceRequestOld = {
  discount: DiscountInfo | undefined;
  r: PriceRequestWithProductCount;
};

export function mapToPriceRequest(
  priceCalculationRequest: PriceCalculationRequest,
): PriceRequestOld | null {
  if (priceCalculationRequest.discountInfo) {
    return {
      discount: {
        ...priceCalculationRequest.discountInfo,
      },
      r: {
        ...priceCalculationRequest.productInfo,
        numberOfProductsInCart: priceCalculationRequest.numberOfProductsInCart,
      },
    };
  }
  return null;
}
